module.exports = __webpack_public_path__ + "static/img/step_bg.05d1d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/followUpInvestigationProject/images/step_bg.png
// module id = 7JLV
// module chunks = 6